/**
 异常管理--配电柜故障上报列表
 */
import React, { PureComponent } from "react";
import FormCore from "@/components/display/form/formCore";
import ScGridTable from "@/components/display/table/gridTableCore";
import PropTypes from "prop-types";
import moment from "moment";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import fetchHandler from "../../../fetch/fetchHandler";
import { useAuth } from "@/utils/utils";
// import { Tooltip } from 'antd';
import {
  powerEventMonitoring,
  stubFaultReportedlevelData,
  getCityList,
  getUpdateTypeList,
  getFrameWorkList,
  getCodeNameList,
  prefixFile,
  getStubGroupDetail,
  getModelNoList,
} from "../../../fetch/fetchApi";
import RefreshGrid from "../../../utils/refreshGrid";
// 国际化切换语言
// import { OPERATIONS_LEVEL } from '@/utils/mapObj';

// eslint-disable-next-line arrow-parens
@connect((state) => state)
class PowerFaultReportingList extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.faultReportingList;
    this.state = {
      visible: false,
      xhList: [],
      levelOption: [],
      formConfig: null,
      typeOption: [
        {
          text: this.props.intl.messages.faultReportingList.operationMode1, // '全部',
          value: "",
        },
      ],
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.getLevel();
    this.setState({
      formConfig: this.initFormConfig(),
    });
    this.init();
  }

  componentDidMount() {
    let param = {
      date: `${moment(new Date()).subtract(29, "d").format("YYYY-MM-DD")},${moment(new Date())
        .subtract(0, "d")
        .format("YYYY-MM-DD")}`,
    };
    if (window.LayoutTab && window.LayoutTab.tabParam) {
      const date = window.LayoutTab.tabParam.date;
      param = {
        ...param,
        ...window.LayoutTab.tabParam,
        date: `${date[0].format("YYYY-MM-DD")},${date[1].format("YYYY-MM-DD")}`,
      };
    }
    this.fetchApi(param);
  }

  // 获取故障等级
  getLevel() {
    fetchHandler(stubFaultReportedlevelData, {
      type: "1",
    }).then((res) => {
      // console.log(res);
      const list = res.data.map((item) => {
        const foo = {
          text: item.name,
          value: item.id,
        };
        return foo;
      });
      const first = {
        text: this.internationalization.operationMode1, // '全部',
        value: "",
      };
      list.unshift(first);
      this.setState(
        {
          levelOption: [...list],
        },
        () => {
          this.setState({
            formConfig: this.initFormConfig(),
          });
        },
      );
      this.init();
    });
  }

  exportOrderStuGroup = (paramString) => {
    const excelUrl = `${prefixFile}/exportpowerFaultReported.do`;
    //   cityId:record.city,
    //   stubGroupId:record.key,
    //   startTime:moment(new Date()).subtract(29, "d").format("YYYY-MM-DD"),
    //   endTime:moment(new Date()).format("YYYY-MM-DD")
    // };
    const ele = document.createElement("a");
    ele.download = encodeURI(`${excelUrl}?${paramString}`);
    ele.style.display = "none";
    ele.href = encodeURI(`${excelUrl}?${paramString}`);
    ele.target = "_blank"; // 针对 ie模式 的浏览器
    // 触发点击
    document.body.appendChild(ele);
    ele.click();
    // 然后移除
    document.body.removeChild(ele);
  };

  init() {
    this.setState({
      tableConfig: {
        tableKey: "eventPowerMonitoringListTable",
        tableColumns: [
          {
            name: "配电柜编号", // 7'配电柜编号',
            key: "modeld",
            colType: "textCol",
            align: "left",
            // render: (value, row) => {
            //   return (
            //     <div onClick={(e) => this.openTab({
            //       // keyId: `stub_${record.key}`,
            //       // StubName: record.name,
            //       stubId: row.stubId,
            //     },
            //     {
            //       key: "0102",
            //       titleText: '设备快速查询', // '设备快速查询',
            //     },)}>
            //       <a>{row.stubId}</a>
            //     </div>
            //   );
            // },
          },
          // {
          //   name: this.internationalization.title10, // '运维等级',
          //   colType: "textCol",
          //   align: "left",
          //   render: (value, row) => {
          //     return (
          //       <div
          //         style={{
          //           display: "flex",
          //           alignItems: "center",
          //           justifyContent: "flex-start",
          //           padding: "0 22px",
          //         }}>
          //         <div className="tip-lv">
          //           <span className="first" style={{ background: row.color }}></span>
          //           <span className="last" style={{ background: row.color }}></span>
          //         </div>
          //         <span>{row.maintLevelName}</span>
          //       </div>
          //     );
          //   },
          // },
          {
            name: "所属电站", // '场站名称',
            key: "stubGroupName",
            colType: "tipCol",
            align: "left",
          },
          {
            name: "运营类型", // '运营类型',
            key: "operationProperty",
            colType: "textCol",
            align: "left",
            width: 200,
            render: (value) => {
              if (value.toString() === "1") {
                return "直营";
              } else if (value.toString() === "0") {
                return "非直营";
              } else {
                return "--";
              }
            },
          },
          {
            name: "所属地区", // '地区',
            key: "cityName",
            colType: "textCol",
            align: "left",
          },
          {
            name: "当前状态", // '运营类型',
            key: "errorStatus",
            colType: "textCol",
            align: "left",
            width: 200,
            render: (value) => {
              if (!value || value == null || (value != "00" && value != "05")) {
                return "--";
              } else if (value == "05") {
                return "离线";
              } else {
                return "在线";
              }
            },
          },
          {
            name: "上报时间", // '上报时间',
            key: "createTime",
            colType: "textCol",
            align: "left",
          },
          {
            name: "操作",
            key: "action",
            colType: "action", // 操作列，可定义多种操作。
            fix: "right",
            width: 80,
            align: "center",
            actionMap: [
              useAuth("040503")
                ? {
                    type: "href",
                    actionName: "一键报修", // '',
                    handler: (res) => {
                      this.goBao(res);
                    },
                  }
                : "",
            ],
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
        },
        dataApi: powerEventMonitoring,
        autoRefresh: !1, // 设置为true 直接加载grid数据
      },
    });
  }

  initFormConfig = () => {
    const formConfig = {
      childItems: [
        {
          type: "input",
          placeholder: "请输入配电站名称", // '请输入',
          param: {
            name: "eventName",
            type: "string",
          },
          labelName: "电站名称", // '故障名称:',
          required: false,
        },
        {
          type: "input",
          placeholder: "请输入配电柜编号", // '请输入设备编号',
          param: {
            name: "stubId",
            type: "string",
          },
          labelName: "配电柜编号", // '设备编号:',
          required: false,
          defaultValue:
            window.LayoutTab && window.LayoutTab.tabParam && window.LayoutTab.tabParam.stubId,
        },
        {
          type: "areaPicker",
          isPickArea: !0,
          placeholder: "请选择所属城市", // '请选择地区',
          pickOnSelect: true,
          param: {
            name: "cityId", // 与form表单绑定的参数名
            type: "array",
          },
          // defaultValue: ['34'], //默认值
          required: !1,
          labelName: "所属地区", // '地区',
          className: "allshow",
          sourceApi: getCityList,
          mapKey: {
            label: "label",
            value: "value",
            children: "children",
          },
        },
        {
          type: "select",
          options: this.state.levelOption,
          placeholder: "请选择运维等级", // '请选择:',
          param: {
            name: "levenId",
            type: "string",
          },
          labelName: this.internationalization.title4, // '运维等级',
          required: !1,
        },
        {
          type: "select",
          placeholder: "请选择运营类型", // '请选择设备状态',
          labelName: "运营类型", // '设备状态',
          param: {
            name: "operationProperty",
            type: "string",
          },
          options: [
            {
              text: "全部",
              value: "",
            },
            {
              text: "非直营",
              value: "0",
            },
            {
              text: "直营",
              value: "1",
            },
          ],
          required: false,
        },
        {
          type: "date",
          dateType: "rangeDate",
          allowClear: false,
          width: "200px",
          placeholder: ["年/月/日", "年/月/日"],
          param: {
            name: "date",
            type: "array",
          },
          defaultValue:
            window.LayoutTab && window.LayoutTab.tabParam && window.LayoutTab.tabParam.date
              ? window.LayoutTab.tabParam.date
              : [moment(new Date()).subtract(29, "d"), moment(new Date()).subtract(0, "d")],
          validator: {
            // 自定义校验对象
            vtype: "date", // 校验名称
            min_val: 0, // 可选最小天数
            // max_val: 7 // 可选最大天数
          },
          labelName: "上报时间", // '日期:',
          required: true,
        },

        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            useAuth("040501")
              ? {
                  btnType: "submit",
                  // icon: 'search',
                  text: this.internationalization.btn1, // '查询'
                }
              : "",
            useAuth("040502")
              ? {
                  btnType: "button",
                  text: "导出", // '导出',
                  handler: (e, param) => {
                    const newParam = param;
                    newParam.token = window.sessionStorage.getItem("token");
                    newParam.companyId = window.sessionStorage.getItem("companyId");
                    newParam.flag = 1;
                    let paramString = "";
                    newParam.cityId =
                      newParam.cityId === undefined
                        ? ""
                        : newParam.cityId
                            .toString()
                            .slice(
                              newParam.cityId.toString().lastIndexOf(",") + 1,
                              newParam.cityId.toString().length,
                            );
                    const date = newParam.date.split(",");
                    newParam.startTime = `${moment(date[0]).format("YYYY.MM.DD")} 00:00:00`;
                    newParam.endTime = `${moment(date[1]).format("YYYY.MM.DD")} 23:59:59`;
                    Object.keys(newParam).forEach((key) => {
                      const paraminfo = newParam[key] ? newParam[key] : "";
                      paramString += `${key}=${paraminfo}&`;
                    });
                    this.exportOrderStuGroup(paramString);
                  },
                }
              : "",
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      defaultParams: {},
      tableKey: "eventPowerMonitoringListTable",
      tablePage: "配电柜离线上报",
    };

    return formConfig;
  };

  fetchApi = (param) => {
    const newParam = param;
    const data = [param.date.split(",")[0], param.date.split(",")[1]];
    if (
      newParam.frameWork == null ||
      newParam.frameWork == "null" ||
      newParam.frameWork == "全部"
    ) {
      newParam.frameWork = "";
    }
    if (
      newParam.updateType == null ||
      newParam.updateType == "null" ||
      newParam.updateType == "全部"
    ) {
      delete newParam.updateType;
    }
    newParam.cityId =
      newParam.cityId === undefined
        ? ""
        : newParam.cityId
            .toString()
            .slice(
              newParam.cityId.toString().lastIndexOf(",") + 1,
              newParam.cityId.toString().length,
            );
    newParam.startTime = `${moment(data[0]).format("YYYY.MM.DD")} 00:00:00`;
    newParam.endTime = `${moment(data[1]).format("YYYY.MM.DD")} 23:59:59`;
    delete newParam.date;

    // 当设置formTarget为grid时，执行自定义提交事件。
    if (this.state.formConfig.formTarget === "grid") {
      return;
    }
    // 请求fetch 对象，带入生成参数
    // 如果在modal中的表单提交，请执行这里
    if (this.props.modalSubmit) {
      return this.props.modalSubmit(newParam);
    } else {
      // 如果正常页面中的表单提交，请执行下面
      return RefreshGrid(this.context.store, "eventPowerMonitoringListTable", newParam);
    }
  };

  openTab(param, e) {
    this.props.onAdd.bind(window.LayoutTab)(e, param);
  }

  goBao(res) {
    fetchHandler(getStubGroupDetail, {
      stubGroupId: res.stubGroupId,
    }).then((result) => {
      window.sessionStorage.removeItem("serviceProvider");
      window.sessionStorage.removeItem("proXType");
      window.sessionStorage.removeItem("isThird");
      window.sessionStorage.removeItem("deee");
      window.sessionStorage.removeItem("hideModal");
      this.openTab(
        {
          // keyId: `stub_${record.key}`,
          // StubName: record.name,

          initSetting: {
            ticketType: 15,
            msg: "配电柜" + res.modeld + "于" + res.createTime + "离线",
            stubGroupId: res.stubGroupId,
            errorId: res.id,
            stuGroupInfo: result,
            codeName: res.codeName,
            isPowerFaultReport: true,
          },
        },
        {
          key: "9103create",
          titleText: "创建工单", // '设备快速查询',
        },
      );
    });
  }

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel gzsbTable">
          <ScGridTable config={this.state.tableConfig} />
        </div>
      </div>
    );

    return Content;
  }
}

export default injectIntl(PowerFaultReportingList);



// WEBPACK FOOTER //
// ./src/AntD/pages/exceptionManagement/powerFaultReporting/powerFaultReportingList.js